'use client';

import _defineProperty from "/codebuild/output/src2867/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src2867/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "unstyled", "variant", "classNames", "styles", "style", "loading", "loaderProps", "size", "color", "radius", "__staticSelector", "gradient", "vars", "children", "disabled", "data-disabled", "autoContrast", "mod"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { getSize, getRadius } from '../../core/utils/get-size/get-size.mjs';
import '@mantine/hooks';
import { createVarsResolver } from '../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { useStyles } from '../../core/styles-api/use-styles/use-styles.mjs';
import { Box } from '../../core/Box/Box.mjs';
import { polymorphicFactory } from '../../core/factory/polymorphic-factory.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import { Loader } from '../Loader/Loader.mjs';
import '../Transition/transitions.mjs';
import { Transition } from '../Transition/Transition.mjs';
import { UnstyledButton } from '../UnstyledButton/UnstyledButton.mjs';
import { ActionIconGroup } from './ActionIconGroup/ActionIconGroup.mjs';
import classes from './ActionIcon.module.css.mjs';
var defaultProps = {};
var varsResolver = createVarsResolver(function (theme, _ref) {
  var size = _ref.size,
    radius = _ref.radius,
    variant = _ref.variant,
    gradient = _ref.gradient,
    color = _ref.color,
    autoContrast = _ref.autoContrast;
  var colors = theme.variantColorResolver({
    color: color || theme.primaryColor,
    theme: theme,
    gradient: gradient,
    variant: variant || "filled",
    autoContrast: autoContrast
  });
  return {
    root: {
      "--ai-size": getSize(size, "ai-size"),
      "--ai-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--ai-bg": color || variant ? colors.background : void 0,
      "--ai-hover": color || variant ? colors.hover : void 0,
      "--ai-hover-color": color || variant ? colors.hoverColor : void 0,
      "--ai-color": colors.color,
      "--ai-bd": color || variant ? colors.border : void 0
    }
  };
});
var ActionIcon = polymorphicFactory(function (_props, ref) {
  var props = useProps("ActionIcon", defaultProps, _props);
  var className = props.className,
    unstyled = props.unstyled,
    variant = props.variant,
    classNames = props.classNames,
    styles = props.styles,
    style = props.style,
    loading = props.loading,
    loaderProps = props.loaderProps,
    size = props.size,
    color = props.color,
    radius = props.radius,
    __staticSelector = props.__staticSelector,
    gradient = props.gradient,
    vars = props.vars,
    children = props.children,
    disabled = props.disabled,
    dataDisabled = props["data-disabled"],
    autoContrast = props.autoContrast,
    mod = props.mod,
    others = _objectWithoutProperties(props, _excluded);
  var getStyles = useStyles({
    name: ["ActionIcon", __staticSelector],
    props: props,
    className: className,
    style: style,
    classes: classes,
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    vars: vars,
    varsResolver: varsResolver
  });
  return /* @__PURE__ */jsxs(UnstyledButton, _objectSpread(_objectSpread(_objectSpread({}, getStyles("root", {
    active: !disabled && !loading && !dataDisabled
  })), others), {}, {
    unstyled: unstyled,
    variant: variant,
    size: size,
    disabled: disabled || loading,
    ref: ref,
    mod: [{
      loading: loading,
      disabled: disabled || dataDisabled
    }, mod],
    children: [/* @__PURE__ */jsx(Transition, {
      mounted: !!loading,
      transition: "slide-down",
      duration: 150,
      children: function children(transitionStyles) {
        return /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread({
          component: "span"
        }, getStyles("loader", {
          style: transitionStyles
        })), {}, {
          "aria-hidden": true,
          children: /* @__PURE__ */jsx(Loader, _objectSpread({
            color: "var(--ai-color)",
            size: "calc(var(--ai-size) * 0.55)"
          }, loaderProps))
        }));
      }
    }), /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread({
      component: "span",
      mod: {
        loading: loading
      }
    }, getStyles("icon")), {}, {
      children: children
    }))]
  }));
});
ActionIcon.classes = classes;
ActionIcon.displayName = "@mantine/core/ActionIcon";
ActionIcon.Group = ActionIconGroup;
export { ActionIcon };